import { render, staticRenderFns } from "./CeremonyBreakdownSection.vue?vue&type=template&id=349d0da0"
import script from "./CeremonyBreakdownSection.vue?vue&type=script&lang=js"
export * from "./CeremonyBreakdownSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports